export const LOCALSTORAGE_CAMPAIGNS = 'LOCALSTORAGE_CAMPAIGNS';
export const SALES = 'sales';

export const VISIT_SALES = 'visit-sales';
export const INSIDE_SALES = 'inside-sales';
